<template>
  <div class="yt-player">
    <div
      ref="container"
      class="yt-player__video"
    />
  </div>
</template>

<script>
import youtubePlayer from './youtube-player';

export default {
  name: 'YouTubePlayer',

  props: {
    autoPlay: {
      type: Boolean,
      default: false,
    },

    id: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    player: null,
  }),

  computed: {
    options() {
      return {
        height: '100%',
        width: '100%',
        // videoId: this.id,
        videoId: 'BY9T0pXU1NM',
      };
    },
  },

  watch: {
    options() {
      this.initPlayer();
    },
  },

  mounted() {
    this.initPlayer();
  },

  methods: {
    async initPlayer() {
      try {
        const Player = await youtubePlayer();
        this.player = new Player(this.$refs.container, {
          ...this.options,
          events: {
            onReady: ({ target }) => {
              if (this.autoPlay) {
                target.playVideo();
                console.log({ target });
              }
            },
          },
        });
      } catch (e) {
        console.error('Unable to init Youtube Player', e);
        this.player = null;
      }
    },
  },
};
</script>
